module.exports = __webpack_public_path__ + "static/media/face_app_trans.ad8ccfc1.png";